import React from 'react';
import { Play } from 'lucide-react';
export function BridgePage() {
  const AFFILIATE_LINK = 'https://ce75fkpxhlrc6s59sgyjv3-no8.hop.clickbank.net';
  // 🔥 TRACKING CLICK PARA META
  const trackAffiliateClick = () => {
    if ((window as any).fbq) {
      ;
      (window as any).fbq('track', 'ViewContent');
    }
  };
  return <main className="min-h-screen w-full bg-white font-sans text-gray-900 selection:bg-red-100 selection:text-red-900" data-id="element-2">
      <div className="mx-auto max-w-2xl px-6 py-12 md:py-16" data-id="element-3">
        {/* Headline */}
        <h1 className="mb-2 text-center text-3xl font-bold leading-tight tracking-tight text-black md:text-4xl lg:text-5xl" data-id="element-4">
          This is why some people cannot burn fat… no matter what they try
        </h1>
        <p className="mb-8 text-center text-lg font-semibold md:text-xl" style={{
        color: '#c40000'
      }} data-id="element-5">
          And it has NOTHING to do with diet, exercise, or willpower
        </p>

        {/* Video/Image Container */}
        <a href={AFFILIATE_LINK} target="_blank" rel="nofollow sponsored noopener" onClick={trackAffiliateClick} className="group relative mb-10 block" aria-label="Watch video explanation" data-id="element-6">
          <div className="aspect-video w-full relative" data-id="element-7">
            <img src="https://cdn.magicpatterns.com/uploads/w91SivZUBE1dWhs1k38AQb/ChatGPT_Image_Jan_29,_2026,_06_12_23_AM.png" alt="Metabolic Block" className="h-full w-full object-cover" data-id="element-8" />

            {/* Dark Overlay for better contrast */}
            <div className="absolute inset-0 bg-black/10 transition-colors group-hover:bg-black/20" data-id="element-9" />

            {/* Play Button Overlay */}
            <div className="absolute left-1/2 top-1/2 flex h-20 w-20 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full bg-red-600 shadow-lg ring-4 ring-white/30 transition-transform group-hover:scale-110 md:h-24 md:w-24" data-id="element-10">
              <Play className="ml-2 h-10 w-10 fill-white text-white md:h-12 md:w-12" data-id="element-11" />
            </div>
          </div>
        </a>

        {/* Body Copy */}
        <article className="prose prose-lg max-w-none text-gray-700" data-id="element-12">
          <p data-id="element-13">Most people think the problem is food.</p>

          <p style={{
          color: '#c40000'
        }} data-id="element-14">
            They are completely wrong.
          </p>

          <p data-id="element-15">
            The real issue happens inside the body before fat burning even
            begins.
          </p>

          <p style={{
          color: '#c40000'
        }} data-id="element-16">
            And almost nobody knows this is happening to them.
          </p>

          <p data-id="element-17">
            That's why diets fail. That's why keto fails. That's why workouts
            fail.
          </p>

          <p style={{
          color: '#c40000'
        }} data-id="element-18">
            Because the body has silently switched into a protective mode.
          </p>

          <p data-id="element-19">Until this is addressed…</p>

          <p style={{
          color: '#c40000'
        }} data-id="element-20">
            Fat loss becomes nearly impossible.
          </p>

          <p data-id="element-21">A short video explains what this hidden "metabolic block" is…</p>

          <p style={{
          color: '#c40000'
        }} data-id="element-22">
            …and why supporting it first changes everything.
          </p>
        </article>

        {/* CTA Button */}
        <div className="mb-4 text-center" data-id="element-23">
          <a href={AFFILIATE_LINK} target="_blank" rel="nofollow sponsored noopener" onClick={trackAffiliateClick} className="inline-flex items-center justify-center w-full sm:w-auto rounded-xl bg-green-500 px-8 py-4 text-base font-semibold text-white shadow-lg hover:bg-green-600 transition" data-id="element-24">
            ▶ Watch the explanation now
          </a>
        </div>

        {/* Below button text */}
        <p className="mb-12 text-center text-sm text-gray-700" data-id="element-25">
          This video is for people who feel like their body refuses to
          cooperate.
        </p>

        {/* Disclosure */}
        <footer className="border-t border-gray-100 pt-8 text-center" data-id="element-26">
          <p className="text-xs text-gray-400" data-id="element-27">
            Disclosure: This site contains affiliate links. We may receive a
            commission if you make a purchase through our links, at no
            additional cost to you. The content on this page is for
            informational purposes only and does not constitute medical advice.
          </p>
        </footer>
      </div>
    </main>;
}